<template>
	<div class="content">
		<h3>顺序码信息绑定</h3>
		<div class="item">
            <el-form ref="form"  inline :model="form" :rules="rules" label-width="100px">
                <el-form-item label="操作方式">
                    <el-radio-group v-model="form.radio" style="display: inline-flex;">
                        <el-radio :label="1">顺序码起始值</el-radio>
                        <el-radio :label="2">输入顺序码</el-radio>
                        <el-radio :label="3">上传文件</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="form.radio === 1" style="margin:-10px 0 0 0; padding:0;" class="item">
                    <el-form-item label="操作数码">
                        <el-input placeholder="请输入起始值" v-model="form.startvalue" clearble></el-input>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-input placeholder="请输入终止值" v-model="form.endvalue" clearble></el-input>
                    </el-form-item>
                    <el-form-item label=" ">
                        <el-input placeholder="请输入剔除值" @keyup.enter.native="deletevalueChange" v-model="deletevalue" clearble></el-input>
                    </el-form-item>
                    <div class="tag">
                        <el-tag @close="romoveDeletevalue(index)" v-for="(tag, index) in form.deletevalue" :key="tag" closable>
                            {{ tag }}
                        </el-tag>
                    </div>
                </div>
                <div v-if="form.radio === 2" style="margin:-10px 0 0 0; padding:0;" class="item" >
                    <el-form-item label="操作数码">
                        <el-input
                        @keyup.enter.native="numChange"
                        v-model="num"
                        clearble
                        ></el-input>
                    </el-form-item>
                    <div class="tag">
                        <el-tag
                        @close="numDeletevalue(index)"
                        v-for="(tag, index) in form.num"
                        :key="tag"
                        closable
                        >
                        {{ tag }}
                        </el-tag>
                    </div>
                </div>
                <div v-if="form.radio === 3" style="margin:-10px 0 0 0; padding:0;" class="item" >
                    <el-form-item label="上传文件" style="display:block;width:100%;">
                        <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" 
                        :on-preview="handlePreview" :on-remove="handleRemove"
                        list-type="picture"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip" style="width:300px;">
                            只能上传jpg/png文件，且不超过500kb
                        </div>
                        </el-upload>
                    </el-form-item>
                </div>

				<el-form-item label="产品" prop="productNum" style="width:100%">
					<el-input placeholder="请选择" v-model="form.productNum"></el-input>
				</el-form-item>
				<el-form-item label="生产工厂" prop="storage">
					<el-select v-model="form.storageId" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产车间" prop="storageType">
					<el-select v-model="form.storageType" placeholder="请选择">
						<el-option
						v-for="item in storage"
						:key="item.type"
						:label="item.storage"
						:value="item.type">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产线">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产班组">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品批号">
                    <el-input placeholder="请输入产品批号，不超过20个字符" v-model="form.endvalue" clearble></el-input>
                </el-form-item>
				<el-form-item label="供应商">
                    <el-input placeholder="请输入供应商，不超过20个字符" v-model="form.endvalue" clearble></el-input>
                </el-form-item>	
				<el-form-item label="质检员">
                    <el-input placeholder="请输入质检员，不超过20个字符" v-model="form.endvalue" clearble></el-input>
                </el-form-item>
                <el-form-item label="保质期">
                    <el-input placeholder="请输入保质期" v-model="form.endvalue" clearble></el-input>
                </el-form-item>
                <el-form-item label="生产日期">
                    <el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
                </el-form-item>
                <el-form-item label="截至有效期">
                    <el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
                </el-form-item>
			</el-form>
			<span style="margin: 0 0 20px 100px;">
				<el-button type="primary" @click="SetStorage">提 交</el-button>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			fileList: [],
			form:{
				CID:'',
				factoryID:'',
				username:'',
				password:'',
				confirm:'',
				name:'',
				sex:'',
				tel:'',
				warehouse:'',
				state:'',
				isAgcy:'',
                operate:1,
                radio:1,
			},
			rules: {
        		factoryID:[
          			{ required: true, message: '请选择正确的工厂', trigger: 'change' }
        		],
        		username:[
          			{ required: true, message: '请输入用户名', trigger: 'blur' }
        		],
        		password:[
          			{ required: true, message: '请输入密码', trigger: 'blur' }
        		]
			},
			factory:[],
			storage:[{
				type:0,
				storage:"生产入库"
			},{
				type:1,
				storage:"退货入库"
			}],
			tableData: [],
			productVisible: false,
			input:'',
			WLData: [],
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.form.CID=user.QyNum;

	},
	methods: {
		add1(){
			if(this.input!=""&&this.input!=null){
				this.WLData.push(this.input)
				this.input=null
			}
		},
		delete1(index){
			this.WLData.splice(index,1)	
		},
		change(data){

		},
		success(response, file, fileList){
			if(response.Code==0){
				this.$message({
				showClose: true,
				message: response.Msg,
				type: "success"
				});
			}else{
				this.$message({
				showClose: true,
				message: response.Msg,
				type: "warning"
				});
			}   
		},
		upload(){
			this.$refs.upload.submit()
		},
		SelectStorage(){},
		AddStorage(){
			this.dialogVisible=true;
		},
		UpdataStorage(){},
		DisableStorager(){},
		SetStorage(){

			this.dialogVisible=false;
		},
		restForm(){},
		SetStorage(){}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/BindCodeInfo.vue